import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Links from './Links';
import Contents from './Contents';
import MobileContents from './MobileContents';
import SocialLinks from '../SocialLinks';
import Clipboard from '../Clipboard';
import descriptions from '../../../mocks/product-descriptions';
import withErrorBoundary from '../../../decorators/withErrorBoundary';
import { isMobileSelector } from '$common/selectors';

import styles from './description.module.scss';
import styled from 'styled-components';

function Description(props) {
  const isMobile = useSelector(isMobileSelector);
  const {
    url,
    product: {
      singular: productName,
      name,
      title: itemTitle,
      description: itemDescription,
      views
    },
    seo,
    locationData,
    reviews,
    permalink,
    priceList,
    onPlatform
  } = props;
  const isProductsApp = !url;
  const description =
    descriptions[productName] &&
    descriptions[productName]
      .filter(({ id }) =>
        (id === `reviews` && reviews.content && !reviews.content.length) ||
        (!priceList && id === `price`) ||
        (id === 'description' && !itemDescription && !seo.regularText)
          ? false
          : true
      )
      .filter((params) => !(params.hideOnMobile && !isMobile));

  return (
    description && (
      <div
        className={classNames(
          styles.root,
          isProductsApp ? styles.rootProducts : ``
        )}
      >
        {!isMobile && (
          <Container
            columns={isProductsApp ? '9fr 3fr' : '7fr 5fr'}
            className={styles.desktopRoot}
          >
            <div className={styles.contents}>
              <Contents
                productName={productName}
                items={description}
                seo={seo}
                locationData={locationData}
                reviews={reviews}
                priceList={priceList}
                onPlatform={onPlatform}
                itemDescription={itemDescription}
              />
            </div>
            <div className={styles.links}>
              <div className={styles.stickyMenu}>
                <Links
                  items={description.map(({ id, title }) => ({
                    id: `${productName}-${id}`,
                    title
                  }))}
                />
                <div className={styles.socialLinks}>
                  {url && (
                    <SocialLinks
                      url={url}
                      title={`${name} ${itemTitle}`}
                      description={itemDescription}
                      media={
                        views && views.large && views.large[0]
                          ? views.large[0]
                          : `/`
                      }
                    />
                  )}
                  {permalink && (
                    <Clipboard
                      className={styles.clipboard}
                      label="Скопировать ссылку"
                      text={permalink}
                    />
                  )}
                </div>
                {/* {clones && (
                <div className={styles.clones}>
                  <Clones clones={clones} />
                </div>
              )} */}
              </div>
            </div>
          </Container>
        )}
        <div className={styles.mobileRoot}>
          <MobileContents
            itemDescription={itemDescription}
            items={description}
            seo={seo}
            locationData={locationData}
            reviews={reviews}
            priceList={priceList}
            onPlatform={onPlatform}
          />
        </div>
      </div>
    )
  );
}

const Container = styled.div`
  @media (min-width: 940px) {
    display: grid !important;
    grid-template-columns: ${(p) => p.columns};
  }
`;

Description.propTypes = {
  url: PropTypes.string,
  product: PropTypes.object,
  seo: PropTypes.object,
  locationData: PropTypes.object,
  reviews: PropTypes.object,
  permalink: PropTypes.string,
  priceList: PropTypes.string,
  clones: PropTypes.array,
  onPlatform: PropTypes.string
};

export default withErrorBoundary(Description);
